import leForm from './index.vue'
leForm.install = function (Vue) {
  Vue.component(leForm.name, leForm)
}
export default leForm
